import { Typography } from "@mui/material";
import React, { useEffect } from "react";
import InviteeQuestions from "./AdditionalOptions/InviteeQuestions";
const AdditionalOptions = (props) => {
  useEffect(() => {
    document.getElementById("additional").scrollTop =
      document.getElementById("additional").scrollHeight;
  }, []);
  return (
    <div
      id="additional"
      style={{ width: "100%", maxWidth: "900px", marginTop: "40px" }}
    >
      <Typography className="font" variant="h6">
        Additional Options
      </Typography>
      <InviteeQuestions
        setSelectedTab={props.setSelectedTab}
        selectedTab={props.selectedTab}
        eventId={parseInt(props.eventId)}
        data={props.data}
        loading={props.loading}
        refetch={props.refetch}
        error={props.error}
        phoneNumber={props.phoneNumber}
      />
    </div>
  );
};
export default AdditionalOptions;
